export class ProfessionalStep1FormResultKeys {
    static readonly PHONE = 'form_professional_step_1_field_phone';
    static readonly PHONE_EXT = 'form_professional_step_1_field_phone_ext';
    static readonly POSTAL_CODE = 'form_professional_step_1_field_postal_code';
    static readonly COMPANY_NAME = 'form_professional_step_1_field_company_name';
    static readonly COMMERCIAL_BANNER = 'form_professional_step_1_field_commercial_banner';
    static readonly PCA = 'form_professional_step_1_field_pca';
    static readonly ADDRESS = 'form_professional_step_1_field_address';
    static readonly CITY = 'form_professional_step_1_field_city';
    static readonly PROVINCE = 'form_professional_step_1_field_province';
    static readonly MANAGING_SOFTWARE = 'form_professional_step_1_field_managing_software';
    static readonly MANAGING_SOFTWARE_OTHER =
        'form_professional_step_1_field_managing_software_other';

    static readonly COMMUNICATION = 'form_professional_step_1_field_authorization_communication';
}

export interface IProfessionalStep1FormResultModel {
    form_professional_step_1_field_phone: string;
    form_professional_step_1_field_phone_ext: string;
    form_professional_step_1_field_postal_code: string;
    form_professional_step_1_field_company_name: string;
    form_professional_step_1_field_commercial_banner: string;
    form_professional_step_1_field_pca: string;
    form_professional_step_1_field_address: string;
    form_professional_step_1_field_city: string;
    form_professional_step_1_field_province: string;
    form_professional_step_1_field_managing_software: string;
    form_professional_step_1_field_managing_software_other: string;
    form_professional_step_1_field_authorization_communication: boolean;
}
